import api from '../api'
import { compareIds } from '../common/utils'
import _ from 'lodash'

const initialState = {
  isLoading: false,
  list: [],
  item: null,
  variations: [],
  ingredients: [],
  pagination: { page: 0, limit: 20, total: 0 },
}

const parsePagination = (value = '0/20/0') => {
  const values = value.split('/')
  return {
    page: parseInt(values[0], 10),
    limit: parseInt(values[1], 10),
    total: parseInt(values[2], 10),
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case api.getRecipeHeaders.request:
    case api.getRecipes.request:
      return {
        ...state,
        isLoading: true,
      }
    case api.getRecipeHeaders.success:
    case api.getRecipes.success:
      return {
        ...state,
        isLoading: false,
        list: action.payload.filter(Boolean),
        pagination: parsePagination(action.response.headers.pagination),
      }
    case api.getRecipeHeaders.failure:
    case api.getRecipes.failure:
      return {
        ...state,
        isLoading: false,
      }
    case api.getRecipeIngredients.success:
      return {
        ...state,
        isLoading: false,
        ingredients: action.payload,
      }
    case 'addIngredientToRecipe':
      return {
        ...state,
        ingredients: _.unionBy(state.ingredients, action.payload, 'id'),
      }
    case api.getRecipe.request:
      return {
        ...state,
        item: null,
        isLoading: true,
      }
    case api.getRecipe.success:
      return {
        ...state,
        isLoading: false,
        item: action.payload,
      }
    case api.getRecipe.failure:
      return {
        ...state,
        isLoading: false,
      }
    case api.addRecipe.success:
      return {
        ...state,
        list: [...state.list, action.payload],
      }
    case api.deleteRecipe.success:
      return {
        ...state,
        list: state.list.filter(item => !compareIds(item.id, action.route)),
      }
    case api.updateRecipe.success:
      return {
        ...state,
        item: action.payload,
      }
    case api.getRecipeVariants.request:
      return {
        ...state,
        variations: [],
      }
    case api.getRecipeVariants.success:
      return {
        ...state,
        variations: action.payload.sort((v1, v2) => v2.id > v1.id),
      }
    case api.addRecipeVariant.success:
      return {
        ...state,
        variations: [...state.variations, action.payload],
      }
    case api.deleteRecipeVariant.success:
      const path = action.route.split('/')
      const id = path[path.length - 1]
      return {
        ...state,
        variations: state.variations.filter(item => !compareIds(item.id, id)),
      }
    case api.updateRecipeVariant.success:
      return {
        ...state,
        variations: state.variations.map(variation => compareIds(variation.id, action.payload.id) ? action.payload : variation),
      }
    default:
      return state
  }
}
